import { useState } from "react";
import { useParams } from "react-router-dom";
import { useProjectType, useSetProjectTypeVisibility } from "features/ProjectType/data/hooks";
import { confirmHide, showProjectTypeError } from "features/ProjectType/presentation/components/ProjectTypeState";
export default function useProjectTypeDetail() {
  const { id } = useParams();
  const query = useProjectType(id);
  const mutation = useSetProjectTypeVisibility();
  const [editing, setEditing] = useState(false);
  const onSaved = async (record) => {
    query.setData(record);
    await query.refetch();
  };
  const changeVisibility = () => {
    const visible = !query.data.isVisible;
    const submit = async () => {
      try {
        await onSaved(await mutation.mutate(id, visible));
      } catch (error) {
        showProjectTypeError(error);
      }
    };
    if (visible) submit();
    else confirmHide(submit);
  };
  return {
    ...query,
    id,
    editing,
    setEditing,
    changeVisibility,
    onSaved,
    saving: mutation.loading,
    error: mutation.error?.code === "FORBIDDEN" ? mutation.error : query.error,
  };
}
